<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="closeTopUpModal"></div>
    <div class="wrapper">
      <img class="close" @click="closeTopUpModal" src="./../images/close.svg" />
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields" v-if="amountStep">
              <div class="title">{{ $t(`Enter amount`) }}</div>
              <div class="form-fields-wrapper enter-amount">
                <label>
                  <div class="amount-wrapper">
                    <input
                      type="number"
                      :placeholder="$t('Amount')"
                      v-model.number="internalAmount"
                    />
                    <div
                      class="buttons"
                      v-if="
                        settings &&
                        settings.top_up_def_amounts &&
                        settings.top_up_def_amounts.length
                      "
                    >
                      <div
                        v-for="item in settings.top_up_def_amounts"
                        :key="item"
                        @click="internalAmount = item"
                        class="button"
                      >
                        <span class="amount">{{ item }}</span>
                        <img class="img" :src="internalCurrencyImage" alt="" />
                      </div>
                    </div>
                  </div>
                </label>

                <div class="disclaimer desc">{{ exchangeRateDisclaimer }}</div>

                <div
                  v-if="referralInfo.hasBonus && internalAmount > 0"
                  class="referral-info desc"
                >
                  {{
                    $t(
                      "With your active referral code ({code}) you will receive:",
                      { code: referralInfo.code }
                    )
                  }}
                  <div class="bonus-amount">
                    <span>{{ internalAmount }} + </span>
                    <span class="bonus"
                      >{{ bonusAmount }} ({{ referralInfo.percentage }}%
                      bonus)</span
                    >
                    <span> = {{ totalAmount }} {{ internalCurrencyName }}</span>
                  </div>
                </div>

                <button @click="nextStep" class="button">
                  <span>{{ $t(`Next`) }}</span>
                </button>
              </div>
            </div>
            <div class="form-fields" v-if="!amountStep">
              <div class="title">{{ $t(`Enter contact information`) }}</div>
              <div class="form-fields-wrapper">
                <label>
                  <input type="text" :placeholder="$t('Name')" v-model="name" />
                  <div
                    v-if="errors.name && errors.name.length"
                    class="error-message"
                  >
                    {{ errors.name[0] }}
                  </div>
                </label>
                <label>
                  <input
                    type="text"
                    :placeholder="$t('Surname')"
                    v-model="surname"
                  />
                  <div
                    v-if="errors.surname && errors.surname.length"
                    class="error-message"
                  >
                    {{ errors.surname[0] }}
                  </div>
                </label>
                <label>
                  <input
                    type="email"
                    :placeholder="$t('E-mail address')"
                    v-model="email"
                  />
                </label>
                <label for="vti__input vti__phone">
                  <vue-tel-input
                    v-if="allowedCountries.length > 0"
                    v-model="phone"
                    :only-countries="allowedCountries"
                    :default-country="computedDefaultCountry"
                    :auto-default-country="false"
                    mode="international"
                    :auto-format="true"
                    :valid-characters-only="true"
                    :dropdown-options="{
                      showDialCodeInList: true,
                      showDialCodeInSelection: false,
                      showFlags: true,
                      showSearchBox: false,
                      tabindex: 0,
                    }"
                    :input-options="{
                      placeholder: $t('Enter phone number'),
                      disabled: allowedCountries.length === 0,
                    }"
                    @on-input="onPhoneInput"
                    @blur="onPhoneBlur"
                    @country-changed="onCountryChanged"
                    class="modal-phone-input"
                  />
                  <input
                    v-else
                    type="tel"
                    :placeholder="$t('Loading countries...')"
                    disabled
                    class="phone-loading-input"
                  />
                  <div
                    v-if="errors.phone && errors.phone.length"
                    class="error-message"
                  >
                    {{ errors.phone[0] }}
                  </div>
                </label>
                <label>
                  <select
                    v-model="country"
                    :class="{
                      'select-placeholder-text':
                        country == '' || country == null,
                    }"
                  >
                    <option selected value="">{{ $t(`Country`) }}</option>
                    <option
                      v-for="item in countryOptions"
                      :value="item"
                      :key="item.iso2"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    v-if="errors.country && errors.country.length"
                    class="error-message"
                  >
                    {{ errors.country[0] }}
                  </div>
                </label>
                <label>
                  <input type="text" :placeholder="$t('City')" v-model="city" />
                  <div
                    v-if="errors.city && errors.city.length"
                    class="error-message"
                  >
                    {{ errors.city[0] }}
                  </div>
                </label>
                <label>
                  <input
                    type="text"
                    :placeholder="$t('Address')"
                    v-model="address"
                  />
                  <div
                    v-if="errors.address && errors.address.length"
                    class="error-message"
                  >
                    {{ errors.address[0] }}
                  </div>
                </label>
                <label>
                  <input
                    type="text"
                    :placeholder="$t('Post Code')"
                    v-model="postCode"
                  />
                  <div
                    v-if="errors.postCode && errors.postCode.length"
                    class="error-message"
                  >
                    {{ errors.postCode[0] }}
                  </div>
                </label>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title"
                          >{{ $t(`I agree with`) }}&nbsp;</span
                        >
                        <a @click="goToPrivacy" class="title">
                          {{ $t(`privacy policy`) }}</a
                        >
                        <span class="title">&nbsp;{{ $t(`and`) }}&nbsp;</span>
                        <a @click="goToTerms" class="title">{{
                          $t(`terms and conditions`)
                        }}</a>
                      </div>
                    </label>
                  </div>
                  <div class="total">
                    <div class="title price">
                      Top Up: {{ realAmount }} {{ currency }}
                    </div>
                  </div>
                  <button
                    :class="['button', { disabled: !requiredFieldsAreFilled }]"
                    @click="submit"
                  >
                    <span>{{ $t(`Top up`) }}</span>
                  </button>
                </div>
                <div
                  v-if="errors.amount && errors.amount.length"
                  class="error-message"
                >
                  {{ errors.amount[0] }}
                </div>
                <div
                  v-if="errors.currency && errors.currency.length"
                  class="error-message"
                >
                  {{ errors.currency[0] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["openOrderModal"],
  name: "TopUpModal",
  inject: [
    "goToPage",
    "closeTopUpModal",
    "openSignInModal",
    "internalCurrencyName",
    "internalCurrencyImage",
    "exchangeRate",
    "currency",
    "settings",
  ],
  props: {
    topUpAmount: {
      type: Number,
      required: true,
    },
    itemType: {
      type: String,
      default: null,
    },
  },

  components: {},

  data: function () {
    return {
      realAmount: null,
      realCurrency: "",
      internalAmount: 0,
      amount: "",
      amountStep: true,
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      countryId: "",
      city: "",
      address: "",
      postCode: "",
      terms: false,
      countryOptions: [],
      countryOptionsId: [],
      phoneFull: "",
      countryCode: "",
      countryCodeList: [],
      profilePhone: "",
      countryOptionsIso: [],

      errors: {
        name: "",
        surname: "",
        phone: "",
        amount: "",
        country: "",
        city: "",
        address: "",
        postCode: "",
      },

      referralInfo: {
        hasBonus: false,
        percentage: 0,
      },
      currentPhoneObject: null,
    };
  },

  mounted() {
    if (this.topUpAmount && this.topUpAmount > 0) {
      this.internalAmount = this.topUpAmount;
      this.realAmount = this.topUpAmount;
      this.amountStep = false;
    }

    Promise.all([this.getProfile(), this.getCountries()])
      .then(() => {
        // Ensure both profile and countries are loaded before setting default
        this.$nextTick(() => {
          this.setDefaultCountry();
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.openSignInModal();
        } else {
          console.error(err);
        }
      });
  },

  watch: {
    internalAmount(value) {
      if (value < 0) {
        this.internalAmount = 0;
        this.errors.amount = ["Amount cannot be negative"];
      } else {
        this.errors.amount = "";
      }
    },
  },

  computed: {
    bonusAmount() {
      if (this.internalAmount <= 0 || !this.referralInfo.hasBonus) return 0;
      return (
        (this.internalAmount * this.referralInfo.percentage) /
        100
      ).toFixed(2);
    },
    totalAmount() {
      const validAmount =
        this.internalAmount > 0 ? Number(this.internalAmount) : 0;
      const validBonus = this.bonusAmount > 0 ? Number(this.bonusAmount) : 0;
      return (validAmount + validBonus).toFixed(2);
    },
    exchangeRateDisclaimer() {
      return `1 ${this.internalCurrencyName} = ${this.exchangeRate} ${this.currency}`;
    },
    getDefaultCountryIso() {
      return this.phoneCountryCode || this.countryOptionsIso[0];
    },
    allowedCountries() {
      return this.countryOptionsIso && this.countryOptionsIso.length > 0
        ? this.countryOptionsIso.map((iso) => iso.toLowerCase())
        : [];
    },
    computedDefaultCountry() {
      if (this.allowedCountries.length > 0) {
        return this.phoneCountryCode
          ? this.phoneCountryCode.toLowerCase()
          : this.allowedCountries[0];
      }
      return null;
    },
    requiredFieldsAreFilled() {
      // Check if all required fields are filled
      const basicFieldsFilled =
        this.name &&
        this.surname &&
        this.phone &&
        this.realAmount &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode &&
        this.terms;

      // Check if phone number is valid (no errors)
      const phoneIsValid = !this.errors.phone || this.errors.phone.length === 0;

      // Check if phone number is properly validated using the current phone object
      const phoneObjectValid = this.currentPhoneObject
        ? this.validatePhone(this.currentPhoneObject)
        : false;

      return basicFieldsFilled && phoneIsValid && phoneObjectValid;
    },
  },

  methods: {
    calculateRealAmount() {
      if (this.internalAmount && this.internalAmount > 0) {
        this.$http
          .post("calculate-top-up", {
            internal_amount: this.internalAmount,
            user_currency_code: this.currency,
          })
          .then((res) => {
            if (res.data.status === "OK") {
              this.realAmount = res.data.payload.amount_to_pay;
              this.realCurrency = res.data.payload.currency;
              this.amountStep = false;
            } else {
              this.errors = res.data.errors;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    getCountries() {
      return this.$http.get("countries").then((res) => {
        this.countryOptions = res.data.payload;
        this.countryOptionsIso = res.data.payload.map((obj) => obj.iso2);
      });
    },
    getProfile() {
      return this.$http.get("user/profile").then((res) => {
        if (res.status == 200) {
          this.email = res.data.email;
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.phoneCountryCode = res.data.phone_country_code;
          this.address = res.data.address;
          this.postCode = res.data.post_code;
          this.city = res.data.city;
          this.userCountry = res.data.country;
          this.joined = res.data.created_at;
          this.balance = res.data.balance;
        }

        if (res.data.referral_code) {
          this.referralInfo = {
            hasBonus: true,
            percentage: res.data.referral_code_percentage,
            code: res.data.referral_code,
          };
        }
      });
    },
    setDefaultCountry() {
      if (this.userCountry && this.countryOptions.length) {
        // Try to match by iso2 first (from profile country.iso), then by id
        const foundCountry = this.countryOptions.find(
          (item) => item.iso2 == this.userCountry.iso || item.id == this.userCountry.id
        );
        if (foundCountry) {
          this.country = foundCountry;
        }
      }
    },
    phoneDataUpdate(number, phoneObject) {
      this.phoneFull = phoneObject.formattedNumber || number;
    },
    onPhoneInput(number, phoneObject) {
      this.phone = number;
      this.phoneFull = phoneObject?.formattedNumber || number;

      // Clear any existing phone errors when user is typing
      if (this.errors.phone) {
        this.errors.phone = [];
      }

      // Store the phone object for later validation
      this.currentPhoneObject = phoneObject;
    },
    onPhoneBlur() {
      // Validate when user leaves the phone input field
      this.validateCurrentPhone();
    },
    onCountryChanged(country) {
      // Handle country change if needed
    },
    validateCurrentPhone() {
      if (!this.currentPhoneObject) {
        return true;
      }

      const phoneObject = this.currentPhoneObject;

      // Only validate if user has entered something that looks like it could be a complete number
      if (
        phoneObject &&
        phoneObject.countryCode &&
        this.phone &&
        this.phone.length > 5
      ) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        const isSupported =
          this.countryOptionsIso && this.countryOptionsIso.length > 0
            ? this.countryOptionsIso.some(
                (iso) => iso && iso.toLowerCase() === countryCode
              )
            : false;

        if (!isSupported) {
          this.errors.phone = ["This country is not supported"];
          return false;
        }

        // Check if phone number is valid
        if (!phoneObject.valid) {
          this.errors.phone = ["Please enter a valid phone number"];
          return false;
        }
      }

      return true;
    },
    validatePhone(phoneObject) {
      // Check if phoneObject exists and has required properties
      if (!phoneObject) {
        return false;
      }

      // Check if the country is supported by our API
      if (phoneObject.countryCode) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        const isSupported =
          this.countryOptionsIso && this.countryOptionsIso.length > 0
            ? this.countryOptionsIso.some(
                (iso) => iso && iso.toLowerCase() === countryCode
              )
            : false;

        if (!isSupported) {
          return false;
        }
      }
      return phoneObject.valid || false;
    },
    submit() {
      // Validate phone before submission
      if (!this.requiredFieldsAreFilled) {
        // Check specifically if phone is the issue
        if (this.errors.phone && this.errors.phone.length > 0) {
          this.$toast?.error?.(
            this.$t("Please fix phone number errors before proceeding")
          );
          return;
        }

        // Check if phone object is invalid
        if (
          !this.currentPhoneObject ||
          !this.validatePhone(this.currentPhoneObject)
        ) {
          this.errors.phone = [this.$t("Please enter a valid phone number")];
          this.$toast?.error?.(this.$t("Please enter a valid phone number"));
          return;
        }

        // General validation message for other missing fields
        this.$toast?.error?.(this.$t("Please fill in all required fields"));
        return;
      }

      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phoneFull,
        amount: this.realAmount,
        country: this.country.id,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        itemType: this.itemType,
      };

      this.$http
        .post("deposit/validate", data)
        .then((res) => {
          if (res.data.status === "OK") {
            this.closeTopUpModal();
            this.$emit("openOrderModal", {
              orderData: data,
              paymentMethods: res.data.payload,
            });
          } else {
            this.errors = res.data.errors;
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors;
          } else {
            console.error(err);
          }
        });
    },
    nextStep() {
      if (this.internalAmount && this.internalAmount > 0) {
        if (this.topUpAmount && this.topUpAmount > 0) {
          this.realAmount = this.topUpAmount;
          this.amountStep = false;
        } else {
          this.calculateRealAmount();
        }
      }
    },
    goToTerms() {
      this.closeTopUpModal();
      this.goToPage("terms");
    },
    goToPrivacy() {
      this.closeTopUpModal();
      this.goToPage("privacy");
    },
  },
});
</script>
<style scoped>
.referral-info {
  margin-top: 12px;
  padding: 12px;
  /* background-color: #f5f5f5; */
  border-radius: 4px;
}

.bonus-amount {
  margin-top: 8px;
  text-align: center;
  font-weight: 500;
}

.bonus {
  color: #1b9b65;
}
</style>
